import React, { useEffect, useState } from "react";
import { Button, Col, Collapse, Divider, Form, Row } from "antd";
import { Link, useHistory, useParams } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../../..";
import OfferingGroupParams from "../../features/OfferingGroupParams/OfferingGroupParams";
import OfferingGroupTreeTable from "../../features/OfferingGroupTreeTable/OfferingGroupTreeTable";
import "./OfferingGroupCreate.less";
import {
  IOfferingGroup,
  IOfferingGroupCreate,
  IOfferingGroupForm,
} from "../../types/IOfferingGroup";
import {
  createOfferingGroup,
  fetchOfferingGroupId,
  offeringGroupsActions,
} from "../../store/slice/offeringGroupsSlice";
import {
  checkIsLoading,
  infinityDateHttpFormat,
  toHttpFormatEndOfDay,
  toHttpFormatStartOfDay,
} from "../../../../lib/utils";

const OfferingGroupCreate = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const { offeringGroupId } = useParams<{ offeringGroupId: string }>();

  const { createOfferingGroupLoading, offeringGroup } = useAppSelector(
    (state) => state.offeringGroups
  );

  const [offeringGroupParamsForm] = Form.useForm<IOfferingGroupForm>();

  const [mainTreeData, setMainTreeData] = useState<IOfferingGroup | IOfferingGroupCreate>();

  useEffect(() => {
    if (offeringGroupId) {
      dispatch(fetchOfferingGroupId({ offeringGroupId: Number(offeringGroupId) }));
    }
  }, [offeringGroupId]);

  useEffect(() => {
    if (offeringGroup) {
      setMainTreeData({
        ...offeringGroup,
        offeringGroupMembers: [...(offeringGroup?.offeringGroupMembers || []), {}],
      });

      offeringGroupParamsForm.setFieldsValue({
        name: offeringGroup?.name,
        groupingTypeId: offeringGroup?.groupingTypeId,
        fromDate: moment(offeringGroup?.fromDate),
        toDate: moment(offeringGroup?.toDate),
        fromDateRecord: moment(offeringGroup?.fromDate),
        toDateRecord: moment(offeringGroup?.toDate),
      });
    }
  }, [offeringGroup]);

  useEffect(() => {
    return () => {
      setMainTreeData(undefined);
      offeringGroupParamsForm.resetFields();
      dispatch(offeringGroupsActions.cleanOfferingGroup());
    };
  }, []);

  const onFinish = () => {
    const params: IOfferingGroupCreate = {
      ...offeringGroupParamsForm.getFieldsValue(["name", "groupingTypeId", "dsc"]),
      fromDate: toHttpFormatStartOfDay(offeringGroupParamsForm?.getFieldValue(["fromDate"])),
      toDate: toHttpFormatEndOfDay(offeringGroupParamsForm?.getFieldValue(["toDate"])),
      offeringGroupMembers: mainTreeData?.offeringGroupMembers.map((el) => {
        return {
          ...el,
          offering: undefined,
          offeringGroup: undefined,
        };
      }),
    };

    dispatch(createOfferingGroup(params)).then((res) => {
      if (res?.payload?.id) {
        setTimeout(() => {
          if (res) history.push(`/offering-groups/${res?.payload?.id}`);
        }, 1000);
      }
    });
  };

  return (
    <div className="offering-group-create">
      <Row className="offering-group-create-title" align="middle">
        <Link to="/offering-groups">
          <LeftOutlined style={{ fontSize: 16 }} />
        </Link>

        <h1>Создание группы</h1>

        <Divider className="offering-group-create-divider" />
      </Row>

      <Form
        form={offeringGroupParamsForm}
        onFinish={onFinish}
        labelAlign="right"
        initialValues={{ fromDate: moment(), toDate: moment(infinityDateHttpFormat).endOf("day") }}
        style={{ width: "100%" }}
      >
        <OfferingGroupParams mode="create" offeringGroupParamsForm={offeringGroupParamsForm} />

        <Divider
          className="offering-group-create-divider"
          style={{ marginTop: "-10px", marginBottom: 0 }}
        />

        <OfferingGroupTreeTable
          mode="create"
          offeringGroupParamsForm={offeringGroupParamsForm}
          mainTreeData={mainTreeData}
          setMainTreeData={setMainTreeData}
        />
      </Form>

      <Row align="middle" style={{ paddingTop: "10px" }} justify="center">
        <Col
          span={24}
          style={{
            textAlign: "center",
          }}
        >
          <Button
            style={{
              margin: "0 8px",
            }}
            onClick={() => {
              history.push(`/offering-groups`);
            }}
          >
            Отмена
          </Button>
          <Button
            type="primary"
            onClick={() => {
              offeringGroupParamsForm.submit();
            }}
            loading={checkIsLoading(createOfferingGroupLoading)}
            disabled={
              !mainTreeData?.offeringGroupMembers[mainTreeData?.offeringGroupMembers?.length - 1]
                ?.offering &&
              !mainTreeData?.offeringGroupMembers[mainTreeData?.offeringGroupMembers?.length - 1]
                ?.offeringGroup
            }
          >
            Создать
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default OfferingGroupCreate;
